import React from 'react';

import { Tag } from 'antd';
import { T } from 'react-translator-component';

import { CrossTransaction } from '../../../types/responses/Interoperability';
import { fullMoment } from '../../organisms/Interoperability/detailFormat';
import {
  DetailCard,
  DetailHint,
  DetailMono,
  DetailRow,
  DetailTitle,
  DetailValue,
} from '../../organisms/Interoperability/styled';
import { chargeDuration, formatEnergy, formatMoney, stationLabel } from '../../organisms/Interoperability/transactionFormat';
import { paymentStatusView } from '../../organisms/Interoperability/TransactionsTab/crossPaymentStatus';


export type TransactionDrawerDetailsProps = {
  charge: CrossTransaction;
};

/**
 * Detalhe de uma recarga cruzada (MV2-1706).
 *
 * O que a linha não cabe e a conferência de faturamento exige: o id da transação, a
 * estação com código, o conector, e os dois instantes exatos. O usuário continua
 * mascarado — o mascaramento é do servidor, e o painel não tem como desfazê-lo nem
 * deve dar a impressão de que teria.
 */
export const TransactionDrawerDetails: React.FC<TransactionDrawerDetailsProps> = ({ charge }) => {
  const station = stationLabel(charge);
  const payment = paymentStatusView(charge.payment_status);

  return (
    <div>
      <DetailCard>
        <DetailTitle>{T('Charge')}</DetailTitle>

        <DetailRow>
          {T('Identifier')}
          <DetailValue>
            <DetailMono>{charge.transaction_id}</DetailMono>
          </DetailValue>
        </DetailRow>

        <DetailRow>
          {T('Started at')}
          <DetailValue>{fullMoment(charge.start_timestamp)}</DetailValue>
        </DetailRow>

        <DetailRow>
          {T('Ended at')}
          <DetailValue>
            {charge.in_progress ? T('in progress') : fullMoment(charge.stop_timestamp)}
          </DetailValue>
        </DetailRow>

        <DetailRow>
          {T('Duration')}
          <DetailValue>{chargeDuration(charge)}</DetailValue>
        </DetailRow>
      </DetailCard>

      <DetailCard>
        <DetailTitle>{T('Station')}</DetailTitle>

        <DetailRow>
          {T('Name')}
          <DetailValue>{station.title}</DetailValue>
        </DetailRow>

        <DetailRow>
          {T('OCPP code')}
          <DetailValue>{station.subtitle || charge.charge_box_code || '—'}</DetailValue>
        </DetailRow>

        <DetailRow>
          {T('Connector')}
          <DetailValue>{charge.connector_seq ?? '—'}</DetailValue>
        </DetailRow>

        <DetailRow>
          {T('Identifier')}
          <DetailValue>
            <DetailMono>{charge.charge_box_id || '—'}</DetailMono>
          </DetailValue>
        </DetailRow>
      </DetailCard>

      <DetailCard>
        <DetailTitle>{T('Origin')}</DetailTitle>

        <DetailRow>
          {T('Partner')}
          <DetailValue>{charge.origin_tenant_name || '—'}</DetailValue>
        </DetailRow>

        <DetailRow>
          {T('User')}
          <DetailValue>
            <DetailMono>{charge.masked_user || '—'}</DetailMono>
          </DetailValue>
        </DetailRow>

        <DetailHint>{T('Users from other tenants are always masked')}</DetailHint>
      </DetailCard>

      <DetailCard>
        <DetailTitle>{T('Numbers')}</DetailTitle>

        <DetailRow>
          {T('Energy')}
          <DetailValue>{formatEnergy(charge.energy_kwh)} kWh</DetailValue>
        </DetailRow>

        <DetailRow>
          {T('To invoice')}
          <DetailValue>{formatMoney(charge.income)}</DetailValue>
        </DetailRow>

        <DetailRow>
          {T('Payment')}
          <DetailValue>
            {payment ? <Tag color={payment.color}>{payment.label}</Tag> : '—'}
          </DetailValue>
        </DetailRow>
      </DetailCard>
    </div>
  );
};
